<template lang='pug'>
div
  v-row(no-gutters style='justify-content: flex-end')
      v-col(cols='auto')
        DataProvider(:endpoint='mountUrlAndParams("menuList").url' baseUrl='/placeholder' :filter='mountUrlAndParams("menuList").filter' @success='mapper($event)')
          div(slot-scope='{ data: response, loading }')
            v-select(
                v-model="menu"
                :close-on-content-click='false'
                :hint="`${menu.key}`"
                :items="menuList"
                item-text="key"
                item-value="value"
                label="Menu"
                persistent-hint
                return-object
                single-line
                @input="changeSubMenu"
                style="margin-right: 5%"
                )
      v-col(cols='auto' v-if='false')
          v-select(
                  v-model="submenu"
                  :close-on-content-click='false'
                  :hint="`${submenu.name}`"
                  :items="subMenuList"
                  item-text="name"
                  item-value="value"
                  label="Sub Menu"
                  persistent-hint
                  return-object
                  single-line
                  @input="changeList"
                  on
                  style="margin-right: 5%"
                  )
</template>
<script>
import DataProvider from '@/components/DataProvider'
import { mapFields } from 'vuex-map-fields'
export default {
  components: {
    DataProvider
  },
  // menuObj: {
  //   type: Object,
  //   default: () => ({
  //     menu: { key: 'Todos', value: 'all' },
  //     subMenu: { key: 'Todos', value: 'all' }
  //   })
  // },
  computed: {
    ...mapFields('reports', ['dateInterval'])
  },
  data () {
    return {
      menuData: [],
      showSubMenu: false,
      menu: { key: this.$t('menuSubMenu.all'), value: 'all' },
      submenu: { name: this.$t('menuSubMenu.all'), value: 'all' },
      menuList: [
        { key: this.$t('menuSubMenu.all'), value: 'all', subMenu: [] }
      ],
      subMenuList: [
        { name: this.$t('menuSubMenu.all'), value: 'all' }
      ]
    }
  },
  methods: {
    mountUrlAndParams (endpoint) {
      const from = this.dateInterval.timestamp1
      const to = this.dateInterval.timestamp2
      const select = this.dateInterval.select?.value ?? 'all'
      return {
        url: `${process.env.VUE_APP_REPORTS_BACKEND}/reports/${endpoint}`,
        filter: { to: to, from: from, select: select }
      }
    },
    mapper (response) {
      this.changeList()
      response.data.data.forEach((item) => {
        this.menuList.push({ key: item.name, value: item.name, subMenu: item.submenu })
      })
    },
    changeSubMenu (event) {
      //  this.showSubMenu = true
      const first = this.subMenuList[0]
      this.subMenuList = event.subMenu
      this.subMenuList.unshift(first)
      this.changeList()
    },
    changeList () {
      this.$emit('update', { menu: this.menu, submenu: this.submenu })
    }
  }
}
</script>
